import { useState } from "react";

import { t } from "i18n/i18n";
import { Banner } from "mds/components/Banner";

export const StudentEditingUnsubmittableBanner = () => {
  const [showBanner, setShowBanner] = useState(true);

  return showBanner ? (
    <Banner className="page-block-width" kind="warning" onDismiss={() => setShowBanner(false)}>
      {t("warning.editing_unsubmittable_draft")}
    </Banner>
  ) : null;
};
